import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit'
import Config from '../../../../Config';
import { prepareUrl } from '../../../../utilities/StringHelpers/StringHelpers'

const OutsideBusinessHours = (props) => {
  return (
    <Container className='outsideBusinessHoursMainContainer'>
      <Row>
        <Col >
          <Row>
            <Col className='clockImgContainer'>
              <Image src={require('../images/icon-120-clock.svg')} alt='clock-icon' />
            </Col>
          </Row>
          <Row>
            <Col >
              <Row>
                <Col className='mainTitle'>חשוב לנו שתדעו</Col>
              </Row>
              <br />
              <Row>
                <Col className='detailsTextContainer'>
                  <p className='detailsFirstLine'>
                    ניתן לנייד קו רק בשעות הפעילות:
                  </p>
                  <p className='detailsSecondLine'>
                    ימי חול בשעות 20:00 - 8:00
                    <br />
                    בימי ו׳ וערבי חג בשעות 12:00 - 8:00
                  </p>
                  <br />
                  <p className='detailsThirdLine'>
                    תוכלו לסיים את הניוד לסלקום עם חידוש שעות הפעילות
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row >
      <Row>
        <Col>
          <BtnSubmit
            text='הבנתי, תודה'
            onclick={() => prepareUrl(props.iContent?.endButtonUrl?.value, props.context)}
          />
        </Col>
      </Row >
    </Container >
  )
}

export default OutsideBusinessHours;